import Button from 'components/form-elements/buttons/Button'
import Input from 'components/form-elements/input/Input'
import { useRequest } from 'hooks/useRequest'
import { useState } from 'react'
import useToast from 'hooks/useToast'
import { useEffect } from 'react'
import LoaderTwo from 'pages/LoaderTwo'
import useTranslate from 'hooks/useTranslate'

let SecurePassword = ({ value, onChange, mask, label, name }) => {
	let updatePass = (e) => {
		let newValue = e.target.value
		let newLength = newValue.length / mask.length
		let oldLength = value.length * mask.length

		if (value.length < newLength) onChange(value + newValue.slice(oldLength))

		if (value.length > newLength) onChange(value.slice(0, newLength))
	}

	return (
		<div className='w-100'>
			<div>{label}</div>
			<input value={mask.repeat(value?.length)} name={name} onChange={updatePass} className='information-input ' />
		</div>
	)
}

const StageResetPassword = () => {
	const [request, loading] = useRequest()
	const { showToast } = useToast()
	const {t} = useTranslate()
	const query = new URLSearchParams(window.location.search)
	const token = query.get('token')

	useEffect(() => {
		document.title = 'Şifremi Yenile'
	}, [])

	const [resetPassword, setResetPassword] = useState({
		email: '',
		token: token,
	})

	const [newPassword, setNewPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')

	const setPassword = () => {
		request('/InternalAuth/PasswordReset', {
			method: 'POST',
			data: {
				email: resetPassword.email,
				token: token,
				newPassword: newPassword,
				confirmPassword: confirmPassword,
			},
		}).then((res) => {
			if (res?.data) {
				if (res?.data?.ok) {
					showToast(t('passwordChanged'), 'success')
				}
			}
		})
	}

	const handleChange = (e) => {
		setResetPassword((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value }))
	}

	return (
		<div className='d-flex flex-column gap-4  m-auto p-3 register-login-container'>
			<LoaderTwo isDataLoading={loading} />
			<Input
				containerClassName={'mt-5 '}
				className={''}
				placeholder={t('labelMail')}
				type={'text'}
				textLabel={t('labelMail')}
				name='email'
				value={resetPassword.email}
				onChange={handleChange}
			/>
			<SecurePassword value={newPassword} name='newPassword' onChange={setNewPassword} mask='*' label={t('labelPassword')} />

			<SecurePassword value={confirmPassword} onChange={setConfirmPassword} mask='*' name='confirmPassword' label={t('labelConfirmPassword')} />

			<div className='register-container-btnGroup stage3-btn-group'>
				<Button onClick={setPassword} className={'stageTwoBtnRed'} icon={''} text={t('saveBtn')} />
			</div>
		</div>
	)
}

export default StageResetPassword
